export const osmosisVideoUrl = 'https://www.osmosis.org';
